import * as React from "react";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";

import classes from "./PopOverItem.module.css";

export default function PopOverItem({
  identifier = Math.random().toString(),
  Icon,
  text,
  Component,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? `simple-popover-${identifier}` : undefined;

  return (
    <div>
      <div aria-describedby={id} onClick={handleClick}>
        <IconButton text={text} Icon={Icon} anchorEl={anchorEl} />
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
      >
        {Component}
      </Popover>
    </div>
  );
}

const IconButton = ({ Icon, text, anchorEl }) => {
  const isOpen = Boolean(anchorEl);
  return (
    <div
      className={`${classes?.iconButtonMain} ${
        isOpen && classes?.iconButtonActive
      }`}
    >
      <Icon size={40} />
      <p>{text}</p>
    </div>
  );
};
